import { api } from './client';
import type { CreateUserRequest, UpdateUserRequest, UserSummaryDto } from './types';

export const usersApi = {
  list: () => api.get<UserSummaryDto[]>('/api/users'),
  create: (request: CreateUserRequest) => api.post<UserSummaryDto>('/api/users', request),
  update: (id: string, request: UpdateUserRequest) =>
    api.put<UserSummaryDto>(`/api/users/${encodeURIComponent(id)}`, request),
  resetPassword: (id: string, temporaryPassword: string) =>
    api.post<void>(`/api/users/${encodeURIComponent(id)}/reset-password`, { temporaryPassword }),
};
